export default __webpack_public_path__ + "static/media/babylift.cbce6fd9.jpeg";